import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class FivewhyService {

  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) {
  }

  getFiveWhyData(headerId: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.get<any[]>(this.baseUrl + 'find-five-why', { headers: header, params: { headerId: headerId } });
    return this.http.get<any[]>(this.O3CoreApiUrl + 'ATFiveWhy/ShowFiveWhy', { headers: header, params: { headerId: headerId } });
  }

  updateFiveWhyData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any[]>(this.baseUrl + 'update-five-why', data, { headers: header });
   return this.http.put<any[]>(this.O3CoreApiUrl + 'ATFiveWhy/UpdateFiveWhy', data, { headers: header });
  }

  addFiveWhyData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any[]>(this.baseUrl + 'add-five-why', data, { headers: header });
    return this.http.post<any[]>(this.O3CoreApiUrl + 'ATFiveWhy/AddFiveWhy', data, { headers: header });
  }
  addFiveWhyActionData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.post<any[]>(this.baseUrl + 'add-five-why-plan', data, { headers: header });
    return this.http.post<any[]>(this.O3CoreApiUrl + 'ATFiveWhyActionPlan/AddFiveWhyPlan', data, { headers: header });
  }

  getFiveWhyPlanData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.get<any[]>(this.baseUrl + 'find-five-why-plan', { headers: header, params: data });
    return this.http.get<any[]>(this.O3CoreApiUrl + 'ATFiveWhyActionPlan/ShowFiveWhyActionPlan', { headers: header, params: data });
  }

  updateFiveWhyPlanData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    // return this.http.put<any[]>(this.baseUrl + 'update-five-why-plan', data, { headers: header });
   return this.http.put<any[]>(this.O3CoreApiUrl + 'ATFiveWhyActionPlan/UpdateFiveWhyPlan', data, { headers: header });
  }

}
